import React from "react";

import { ErrorDetail } from "../../../components/ErrorDetail/ErrorDetail";

export const Error400: React.FC = () => {
  return (
    <>
      <ErrorDetail variant="error400" />
    </>
  );
};
